export const OFFSET_FROM_TRIGGER = 4;
export const OFFSET_FROM_SIDE_BORDER = 1;
export const OFFSET_FROM_SCREEN_BOTTOM_BORDER = 10;
